import { ModalDialog } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { PopupProps } from 'react-popup-manager';

interface PreventModalComponentProps extends React.PropsWithChildren, PopupProps {
    title: string | React.ReactNode;
    cancelButtonText?: string;
}

export const PreventModalComponent: React.FC<PreventModalComponentProps> = (props) => {
    const { isOpen, title, children, cancelButtonText, onClose } = props;

    const { t } = useTranslation();

    return (
        <ModalDialog
            title={title}
            onlyCloseAction
            cancelButtonText={cancelButtonText ?? t('commons.components.button.close')}
            onClose={onClose}
            isOpen={isOpen}
        >
            {children}
        </ModalDialog>
    );
};
